import { useCallback, useMemo, useState } from "react";
import { RouterProvider } from "@tanstack/react-router";
import { AppProviders } from "@/app/providers/AppProviders";
import { createQueryClient } from "@/app/providers/query-client";
import { createAppRouter } from "@/app/router/router";
import { MsalRedirectHandler } from "@/features/auth/components/MsalRedirectHandler";
import { msalInstance } from "@/app/providers/MsalProvider";
import { extractRolesFromAccount } from "@/app/providers/useAuth";

export function App() {
  const [queryClient] = useState(createQueryClient);

  const getOrSetActiveAccount = useCallback(() => {
    const active = msalInstance.getActiveAccount();
    if (active) {
      return active;
    }

    const all = msalInstance.getAllAccounts();
    if (all.length > 0) {
      msalInstance.setActiveAccount(all[0]);
      return all[0];
    }

    return null;
  }, []);

  const router = useMemo(
    () =>
      createAppRouter({
        queryClient,
        isAuthenticated: () => {
          return Boolean(getOrSetActiveAccount());
        },
        getUserRoles: () => {
          const account = getOrSetActiveAccount();
          return extractRolesFromAccount(account);
        },
      }),
    [queryClient, getOrSetActiveAccount]
  );

  return (
    <AppProviders queryClient={queryClient}>
      <MsalRedirectHandler />
      <RouterProvider router={router} />
    </AppProviders>
  );
}

export default App;
